import { render, staticRenderFns } from "./Toolhead.vue?vue&type=template&id=443a7019&scoped=true&"
import script from "./Toolhead.vue?vue&type=script&lang=ts&"
export * from "./Toolhead.vue?vue&type=script&lang=ts&"
import style0 from "./Toolhead.vue?vue&type=style&index=0&id=443a7019&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443a7019",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCol,VRow})
